import React from 'react'
import {Modal} from 'react-bootstrap'

const CancelTestModal = (props) => {

    const onOk = (e) => {
        e.preventDefault();
        props.onOk();
    }

    const onCancel = (e) => {
        e.preventDefault();
        props.onCancel();
    }

    return <div className="vertical-alignment-helper">
        <div className="modal-dialog vertical-align-center">
            <Modal.Dialog >
                <Modal.Header>
                    <Modal.Title>CANCEL TEST</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className='plaintext'>
                        Are you sure you would like to cancel this test? This action cannot be undone
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button onClick={onOk} className='submit'>Yes</button>
                    <button onClick={onCancel} className='submit'>No</button>
                </Modal.Footer>
            </Modal.Dialog>
        </div>
    </div>
}

export default CancelTestModal


// WEBPACK FOOTER //
// ./src/components/tests/CancelTestModal.jsx